import React from 'react';
import SimpleMath from './simpleMath';
import GraphingCalculator from './Lessonmods/graphingCalculator';

export default class LessonUtils {
    // The offsets here are designed for a lesson page context, assuming the
    // page has the Table of Contents feature.
    static scrollToRef(ref, requestedOffset) {
        // note: the timeout is to wait for a render cycle so that the ref is stably positioned on the screen before scrolling
        setTimeout(() => {
            var offset = requestedOffset ? requestedOffset : (window.matchMedia("screen and (max-width: 850px)").matches ? 180 : 140);
            window.scrollTo({top: ref.current.offsetTop - offset , behavior: "smooth"});
        }, 32)
    }

    static scrollToInnerRef(ref, outerRef) {
        // note: the timeout is to wait for a render cycle so that the ref is stably positioned on the screen before scrolling
        setTimeout(() => {
            var offset = window.matchMedia("screen and (max-width: 850px)").matches ? 180 : 140;
            window.scrollTo({top: outerRef.current.offsetTop + ref.current.offsetTop - offset, behavior: "smooth"});
        }, 100)
    }
}

export const math = (mathString, display, size) => <SimpleMath mathString={mathString} display={display} size={size}/>;

// mathStrings is a list of the lines with desired alignment
export const multiMath = (mathStrings, display, size) => {
    if (mathStrings) {
        let finalString = '\\begin{aligned} ';
        for (const mathString of mathStrings) {
            finalString += mathString + ' \\\\';
            if (mathString.includes("\\frac")) {
                finalString += "[1em]"
            }
        }
        finalString += ' \\end{aligned}';

        return <SimpleMath mathString={finalString} display={display} size={size}/>;
    }
    return <></>;
};

export const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const validDecFracValue = (value) => {
    return value !== undefined && value > 0 && value !== Infinity;
};

export const round = (x, precision=5) => {
    return Number(Number(x).toFixed(precision));
};

export const getEqualSign = (x) => {
    return Math.abs(x - Number(x.toFixed(5))) < Math.pow(10, -12)
        ? '='
        : '\\approx';
};

export const shuffle = (array)  => {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
};

export const getDeterminer = (word) => {
    return 'aeiou'.includes(word.charAt(0)) ? 'an' : 'a';
};

export const permuteArray = (inputArr) => {
    let result = [];
    const permute = (arr, m = []) => {
        if (arr.length === 0) {
            result.push(m)
        } else {
            for (let i = 0; i < arr.length; i++) {
                let curr = arr.slice();
                let next = curr.splice(i, 1);
                permute(curr.slice(), m.concat(next))
            }
        }
    }
    permute(inputArr)
    return result;
}

// Takes in a list of points and/or polygons
// Each point is of the form
// { x: 1, y: 2, color: COLORS.SUMMER_POOL }
// Each polygon is of the form
// { points: [{ x: 1, y: 2}, {x: 2, y: 3}, {x: -2, y: 5}], color: COLORS.ORANGE_AF }
export const graphPolygonsAndPoints = (points, polygons, name, bounds, xStep, yStep) => {
    const pointExpressions = points.map(point => {
        return {
            exp: `(${point.x}, ${point.y})`,
            color: point.color,
        };
    });

    const polygonExpressions = polygons.map(polygon => {
        const polygonPoints = [];

        for (let point of polygon.points) {
            polygonPoints.push(`(${point.x}, ${point.y})`);
        }

        return {
            exp: `\\operatorname{polygon}(${polygonPoints.join(', ')})`,
            color: polygon.color,
        }
    });

    return <div style={{width: '100%', height: '100%', margin: '1rem auto'}}>
        <GraphingCalculator
            name={name}
            value={{
                expressions: [
                    ...polygonExpressions,
                    ...pointExpressions,
                ],
                gridBounds: bounds,
                lock: true,
            }}
            xStep={xStep}
            yStep={yStep}
        />
    </div>;
};
